module.exports = __webpack_public_path__ + "assets/img/ewm.194d1b85.jpg";